"use strict";

var _themeSections = require("@shopify/theme-sections");

require("../sections/collection-blocks");

require("../sections/collection-grid-slider");

require("../sections/collection-product-slider");

require("../sections/custom-featured-products");

require("../sections/custom-image-slider");

require("../sections/featured-collection");

require("../sections/hero-banner");

require("../sections/image-slider");

require("../sections/shop-by-theme");
/**
 * Template: Index
 * -----------------------------------------------------------------------------
 * Scripts to execute on the index page.
 *
 */


document.addEventListener('DOMContentLoaded', function () {
  (0, _themeSections.load)('*');
});